import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { USER_ROLE_SERVICE_TOKEN } from '../types/tokens';
import { TRole } from '../types/security.types';

@Injectable({ providedIn: 'root' })
export class RoleGuard {
  private user = inject(USER_ROLE_SERVICE_TOKEN);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const role = route.data['role'] as TRole | TRole[] | undefined;
    if (!role) return true;

    const roles = Array.isArray(role) ? role : [role];
    if (roles.some((r) => this.user.isInRole(r))) return true;

    this.router.navigateByUrl('/');
    return false;
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean {
    return this.canActivate(route);
  }
}
